import {Component, Input, OnInit} from '@angular/core';
import { A48HelpersService } from 'src/app/services/a48-helpers/a48-helpers.service';
import { CplItem } from '../../../model/cpl-item.model';
import { DateHelpers, PagedResponse, PortalSettings, SessionService } from '@edl-development/edl-common';
import { ComplianceItemHelpersService } from '../../../services/compliance-item-helpers/compliance-item-helpers.service';
@Component({
    templateUrl: './print-item.component.html',
    styleUrls: ['../../print.component.scss'],
})
export class PrintItemComponent implements OnInit {
    @Input() cplItem:CplItem;
    @Input() itemCycles: PagedResponse;

    portalSettings: PortalSettings;

    DateHelpers = DateHelpers;

    constructor(
        public a48HelpersService: A48HelpersService,
        public complianceItemHelpersService: ComplianceItemHelpersService,
        private sessionService: SessionService
    ) { }

    ngOnInit() {
        this.portalSettings = this.sessionService.PortalSettings;
    }

    isAct48Enabled(){
        return this.portalSettings.Act48Enabled && this.cplItem.Act48Detail != null && this.cplItem.Act48Detail.Applicable;
    }
}